// Third party imports
import { createSlice } from "@reduxjs/toolkit";

export const statsSlice = createSlice({
  name: "stats",
  initialState: {
    stats: null,
  },
  reducers: {
    setStats: (state, action) => {
      state.stats = action.payload;
    },
  },
});
export const { setStats } = statsSlice.actions;
export default statsSlice.reducer;
